import { ReactNode } from 'react';

type FederatedSearchApiControlFallbackProps = {
    setSelectedForm: () => void;
    setQueryFormValues: () => void;
    setQueryFormDataToPrefill: () => void;
};

export const FederatedSearchApiControlFallback = ({
    children,
}: {
    children?: (props: FederatedSearchApiControlFallbackProps) => ReactNode;
}) => (
    <>
        {typeof children === 'function'
            ? children({
                  setSelectedForm: () => {},
                  setQueryFormValues: () => {},
                  setQueryFormDataToPrefill: () => {},
              })
            : null}
    </>
);
